
function AnimationHome(){

    if( $('.home-intro').length == 0 )
        return false;

    let tl = gsap.timeline();

    tl.to( $('.home-intro .home-intro-title-container'), {
        opacity: 0.35,
        y: "-70%",
        duration: 1
    });
    tl.to( $('.home-intro .home-intro-svg .svg:eq(0)'), {
        opacity: 1,
        y: "-20%",
        duration: 0.8,
        delay: 0.5
    });
    tl.to( $('.home-intro .home-intro-svg .svg:eq(1)'), {
        opacity: 1,
        y: "-20%",
        duration: 0.8,
        delay: -0.6
    });
    tl.to( $('.home-intro .home-intro-bg'), {
        opacity: 1,
        duration: 0.8
    });
    tl.to( $('.home .header-main'), {
        opacity: 1,
        duration: 0.7
    });
    tl.to( $('.home-intro .nav-social, .home-intro .nav-lang'), {
        opacity: 1,
        duration: 0.7
    });

    tl.pause();

    $(window).on('transitionDone', function () {
        // tl.play();
    });

    new Particles();

}
